export interface SectionTab {
  label: string
  to: string
  end?: boolean
}

// ============================================
// SECTION TAB CONFIGS
// ============================================

export const MARKETING_TABS: SectionTab[] = [
  { label: "Daily", to: "/marketing", end: true },
  { label: "Breakdown", to: "/marketing/breakdown" },
  { label: "Overview", to: "/marketing/overview" },
  { label: "Lead Sources", to: "/marketing/lead-sources" },
  { label: "Leads", to: "/marketing/leads" },
  { label: "AI Intake", to: "/marketing/ai-intake" },
]

export const COMMUNICATION_TABS: SectionTab[] = [
  { label: "Phone Numbers", to: "/communication/phone-numbers" },
  { label: "Call Routing", to: "/communication/call-flows" },
  { label: "Call Queues", to: "/communication/call-queues" },
  { label: "Blacklist", to: "/communication/blocked-numbers" },
]

export const AUTOMATION_TABS: SectionTab[] = [
  { label: "Assignments", to: "/automations", end: true },
  { label: "Senders", to: "/automations/email-senders" },
]

export const SYSTEM_TABS: SectionTab[] = [
  { label: "Workflows", to: "/system/workflows" },
  { label: "Tags", to: "/system/tags" },
  { label: "Locations", to: "/system/locations" },
  { label: "Bookings", to: "/system/booking-links" },
  { label: "Events", to: "/system/event-templates" },

  { label: "Fields", to: "/system/custom-fields" },
  { label: "Custom Dates", to: "/system/custom-dates" },
  { label: "Expected Dates", to: "/system/expected-dates" },
  { label: "Departments", to: "/system/departments" },
]

export const COMPANY_TABS: SectionTab[] = [
  { label: "Users", to: "/company/users" },
  { label: "Info", to: "/company/edit" },
  { label: "Divisions", to: "/company/divisions" },
  { label: "String Templates", to: "/company/string-templates" },
  { label: "Custom Views", to: "/company/custom-views" },
]

export const DEVELOPER_TABS: SectionTab[] = [
  { label: "Execution Logs", to: "/developers/execution-logs" },
  { label: "Projections", to: "/developers/projections" },
]

export const AI_TABS: SectionTab[] = [
  { label: "Jobs", to: "/ai", end: true },
  { label: "Knowledge", to: "/ai/knowledge" },
]

export const LAYOUT_TABS: SectionTab[] = [
  { label: "Today's Activity", to: "/layout", end: true },
]

export const BULK_TABS: SectionTab[] = [
  { label: "Items", to: "/bulk", end: true },
]

export const ANALYZE_TABS: SectionTab[] = [
  { label: "Select", to: "/analyze", end: true },
]

export const FINANCES_TABS: SectionTab[] = [
  { label: "Billing Categories", to: "/finances", end: true },
  { label: "Templates", to: "/finances/templates" },
  { label: "Rate Cards", to: "/finances/rate-cards" },
]

export const TRAINING_TABS: SectionTab[] = [
  { label: "Courses", to: "/training", end: true },
  { label: "Quizzes", to: "/training/quizzes" },
  { label: "Scenarios", to: "/training/scenarios" },
  { label: "Enrollments", to: "/training/enrollments" },
]


// ============================================
// BREADCRUMB RESOLUTION
// ============================================

export const SECTION_CONFIGS: Record<string, { label: string; tabs: SectionTab[] }> = {
  marketing: { label: "Marketing", tabs: MARKETING_TABS },
  communication: { label: "Communicate", tabs: COMMUNICATION_TABS },
  automations: { label: "Automations", tabs: AUTOMATION_TABS },
  system: { label: "System", tabs: SYSTEM_TABS },
  company: { label: "Company", tabs: COMPANY_TABS },
  developers: { label: "Developers", tabs: DEVELOPER_TABS },
  ai: { label: "AI", tabs: AI_TABS },
  layout: { label: "Layout", tabs: LAYOUT_TABS },
  bulk: { label: "Bulk Actions", tabs: BULK_TABS },
  analyze: { label: "Analyze", tabs: ANALYZE_TABS },
  finances: { label: "Finances", tabs: FINANCES_TABS },
  training: { label: "Training", tabs: TRAINING_TABS },
}

export const SIMPLE_PAGES: Record<string, string> = {
  "custom-views": "Custom Views",
}
